
webpack.register(
    'components/championships-selection-tabs/championships-selection-tabs',
    function() {
        return require('components/championships-selection-tabs/championships-selection-tabs');
    },
    false
);
var stache = require('can/view/stache/stache');
module.exports = stache("<can-import from='components/championships-selection-tabs/championships-selection-tabs' />\r\n<championships-selection-tabs {tabs}=\"data\"/>");